module.exports = __webpack_public_path__ + "static/media/discounts-given.b15cc224.svg";